import styled, { keyframes } from 'styled-components'

const blur = keyframes`
  from {
    backdrop-filter: blur(0);
  } to {
    backdrop-filter: blur(3px);
    background: rgba(255, 255, 255, 0.5);
  }
`

const spin = keyframes`
  from {
    transform: rotate(0deg);
  } to {
    transform: rotate(360deg);
  }
`

export const Container = styled.div.attrs({
  className: 'loading'
})`
  animation: ${blur} 0.5s both linear;

  position: relative;

  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  i {
    position: absolute;
    bottom: 0;
    right: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    padding: 1rem;

    font-size: 3rem;

    animation: ${spin} 2s linear both infinite;
  }
`
